
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/icons",
      function () {
        return require("private-next-pages/components/icons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/icons"])
      });
    }
  